<div id="sidebar">
    <div id="sidebar-menu" class="list-group">
        <ng-container *ngFor="let item of menuItems">
      <span *ngIf="item.visible">
        <ng-container *ngIf="item.label !== 'EXTERNAL INTERFACES'; else createCollapse">
          <a [routerLink]="item.url" [routerLinkActiveOptions]="{}" routerLinkActive="sidebar-item-active"
             class="sidebar-item list-group-item">
            <div class="sidebar-item-wrapper">
              <i [attr.class]="'sidebar-item-icon fa ' + item.icon"></i>
              <span class="sidebar-item-text">
                {{ item.label }}
              </span>
            </div>
          </a>
        </ng-container>
        <ng-template #createCollapse>
          <div class="sidebar-item-wrapper">
            <a (click)="toggleExternalInterfaces()"
               class="sidebar-item list-group-item"
               [ngClass]="{'active': externalInterfacesOpen}">
              <i [attr.class]="'sidebar-item-icon fa ' + item.icon"></i>
              <span class="sidebar-item-text">
                {{ item.label }}
              </span>
            </a>
          </div>
          <div *ngIf="externalInterfacesOpen" class="collapse-group">
            <ng-container *ngFor="let subItem of item.subItems">
              <a *ngIf="subItem.visible"
                 [routerLink]="subItem.url"
                 routerLinkActive="sidebar-item-active"
                 class="list-group-item sidebar-item collapse-group-item">
                {{ subItem.label }}
              </a>
            </ng-container>
          </div>
        </ng-template>
      </span>
        </ng-container>
    </div>
</div>
